import type { BoggleTieredFamilyConfig } from '../familyTypes'

export const BOGGLE_TIERED_FAMILY_CONFIGS: readonly BoggleTieredFamilyConfig[] = [
  {
    category: 'speed',
    descriptionTemplate: 'Play [3 / 4 / 5] words in [3] seconds',
    familyId: 'quickdraw',
    iconId: 'quickdraw',
    lockedReveal: 'reveal',
    name: 'Quickdraw',
    tiers: [
      { tierIndex: 1, level: 'common' },
      { tierIndex: 2, level: 'uncommon' },
      { tierIndex: 3, level: 'rare' },
    ],
  },
  {
    category: 'speed',
    descriptionTemplate:
      'Find [6 / 7 / 8] words of length 5+ in [20] seconds',
    familyId: 'machine',
    iconId: 'machine',
    lockedReveal: 'reveal',
    name: 'Machine',
    tiers: [
      { tierIndex: 1, level: 'uncommon' },
      { tierIndex: 2, level: 'rare' },
      { tierIndex: 3, level: 'legendary' },
    ],
  },
  {
    category: 'length',
    descriptionTemplate: 'Play words of lengths [3–6 / 3–7 / 3–8 / 3–9]',
    familyId: 'versatile',
    iconId: 'versatile',
    lockedReveal: 'reveal',
    name: 'Versatile',
    tiers: [
      {
        tierIndex: 1,
        level: 'common',
        descriptionOverride: 'Play words of lengths 3, 4, 5, and 6',
      },
      {
        tierIndex: 2,
        level: 'uncommon',
        descriptionOverride: 'Play words of lengths 3, 4, 5, 6, and 7',
      },
      {
        tierIndex: 3,
        level: 'rare',
        descriptionOverride: 'Play words of lengths 3, 4, 5, 6, 7, and 8',
      },
      {
        tierIndex: 4,
        level: 'legendary',
        descriptionOverride: 'Play words of lengths 3, 4, 5, 6, 7, 8, and 9',
      },
    ],
  },
  {
    category: 'special',
    descriptionTemplate: 'Charge the gold meter to [100 / 150 / 200]% before Gold Rush',
    familyId: 'prospector',
    iconId: 'prospector',
    lockedReveal: 'reveal',
    name: 'Prospector',
    tiers: [
      { tierIndex: 1, level: 'common' },
      { tierIndex: 2, level: 'uncommon' },
      { tierIndex: 3, level: 'rare' },
    ],
  },
  {
    category: 'speed',
    descriptionTemplate: 'Play [3 / 6 / 10] words during gold rush',
    familyId: 'frenzy',
    iconId: 'frenzy',
    lockedReveal: 'reveal',
    name: 'Frenzy',
    tiers: [
      { tierIndex: 1, level: 'common' },
      { tierIndex: 2, level: 'uncommon' },
      { tierIndex: 3, level: 'rare' },
    ],
  },
  {
    category: 'path',
    descriptionTemplate: 'Play a word using [5 / 6 / 7 / 8+] different tiles',
    familyId: 'cartographer',
    iconId: 'cartographer',
    lockedReveal: 'reveal',
    name: 'Cartographer',
    tiers: [
      { tierIndex: 1, level: 'common' },
      { tierIndex: 2, level: 'uncommon' },
      { tierIndex: 3, level: 'rare' },
      { tierIndex: 4, level: 'legendary' },
    ],
  },
  {
    category: 'letters',
    descriptionTemplate: 'Play [2 / 3] rare letters in a single word',
    familyId: 'pizazz',
    iconId: 'pizazz',
    lockedReveal: 'reveal',
    name: 'Pizazz',
    tiers: [
      { tierIndex: 1, level: 'uncommon' },
      { tierIndex: 2, level: 'rare' },
    ],
  },
  {
    category: 'letters',
    descriptionTemplate:
      'Play a word of length [5 / 6]+ that forms a different word spelled backwards',
    familyId: 'anadrome',
    iconId: 'anadrome',
    lockedReveal: 'reveal',
    name: 'Anadrome',
    tiers: [
      { tierIndex: 1, level: 'common' },
      { tierIndex: 2, level: 'uncommon' },
    ],
  },
  {
    category: 'special',
    descriptionTemplate: 'Play a word containing [2 / 5 / 8] letters added in overtime',
    familyId: 'clutch',
    iconId: 'clutch',
    lockedReveal: 'reveal',
    name: 'Clutch',
    tiers: [
      { tierIndex: 1, level: 'common' },
      { tierIndex: 2, level: 'uncommon' },
      { tierIndex: 3, level: 'rare' },
    ],
  },
  {
    category: 'length',
    descriptionTemplate: 'Play [3] words of length [5 / 6 / 7 / 8]+',
    familyId: 'juggernaut',
    iconId: 'juggernaut',
    lockedReveal: 'reveal',
    name: 'Juggernaut',
    tiers: [
      { tierIndex: 1, level: 'common' },
      { tierIndex: 2, level: 'uncommon' },
      { tierIndex: 3, level: 'rare' },
      { tierIndex: 4, level: 'legendary' },
    ],
  },
  {
    category: 'length',
    descriptionTemplate: 'Play a word of length [8 / 9 / 10]+',
    familyId: 'sesquipedalian',
    iconId: 'sesquipedalian',
    lockedReveal: 'mystery',
    name: 'Sesquipedalian',
    tiers: [
      { tierIndex: 1, level: 'uncommon' },
      { tierIndex: 2, level: 'rare' },
      { tierIndex: 3, level: 'legendary' },
    ],
  },
  {
    category: 'letters',
    descriptionTemplate: 'Play [15 / 17 / 19] different starting letters',
    familyId: 'generalist',
    iconId: 'generalist',
    lockedReveal: 'reveal',
    name: 'Generalist',
    tiers: [
      { tierIndex: 1, level: 'common' },
      { tierIndex: 2, level: 'uncommon' },
      { tierIndex: 3, level: 'rare' },
    ],
  },
  {
    category: 'special',
    descriptionTemplate: 'Play the same gold tile 4 times in one word',
    familyId: 'greedy',
    iconId: 'greedy',
    lockedReveal: 'reveal',
    name: 'Greedy',
    tiers: [{ tierIndex: 1, level: 'uncommon' }],
  },
  {
    category: 'speed',
    descriptionTemplate:
      'Finish a run without exceeding [7 / 5 / 3] seconds between plays',
    familyId: 'battery',
    iconId: 'battery',
    lockedReveal: 'reveal',
    name: 'Battery',
    tiers: [
      { tierIndex: 1, level: 'uncommon' },
      { tierIndex: 2, level: 'rare' },
      { tierIndex: 3, level: 'legendary' },
    ],
  },
  {
    category: 'letters',
    descriptionTemplate: 'Play [18 / 22 / 25 / 26] unique letters',
    familyId: 'pangrammatist',
    iconId: 'pangrammatist',
    lockedReveal: 'reveal',
    name: 'Pangrammatist',
    tiers: [
      { tierIndex: 1, level: 'common' },
      { tierIndex: 2, level: 'uncommon' },
      { tierIndex: 3, level: 'rare' },
      { tierIndex: 4, level: 'legendary' },
    ],
  },
  {
    category: 'letters',
    descriptionTemplate: 'Play a word of length [4 / 5 / 6]+ with letters in alphabetical order',
    familyId: 'abecedarian',
    iconId: 'abecedarian',
    lockedReveal: 'reveal',
    name: 'Abecedarian',
    tiers: [
      { tierIndex: 1, level: 'common' },
      { tierIndex: 2, level: 'uncommon' },
      { tierIndex: 3, level: 'rare' },
    ],
  },
  {
    category: 'mastery',
    descriptionTemplate:
      'Play [10 / 20 / 30] words in a row without backspace or clear / Finish a run with [40]+ unique words',
    familyId: 'steady',
    iconId: 'steady',
    lockedReveal: 'reveal',
    name: 'Steady',
    tiers: [
      {
        tierIndex: 1,
        level: 'common',
        descriptionOverride:
          'Play 10 words in a row without using backspace or clear',
      },
      {
        tierIndex: 2,
        level: 'uncommon',
        descriptionOverride:
          'Play 20 words in a row without using backspace or clear',
      },
      {
        tierIndex: 3,
        level: 'rare',
        descriptionOverride:
          'Play 30 words in a row without using backspace or clear',
      },
      {
        tierIndex: 4,
        level: 'legendary',
        descriptionOverride:
          'Finish a run without using backspace or clear (40+ words)',
      },
    ],
  },
  {
    category: 'mastery',
    descriptionTemplate:
      'Play [10 / 20 / 30] words in a row without repeating a word / Finish a run without repeating a word ([40]+ words)',
    familyId: 'lexicographer',
    iconId: 'lexicographer',
    lockedReveal: 'reveal',
    name: 'Lexicographer',
    tiers: [
      {
        tierIndex: 1,
        level: 'common',
        descriptionOverride: 'Play 10 words in a row without repeating a word',
      },
      {
        tierIndex: 2,
        level: 'uncommon',
        descriptionOverride: 'Play 20 words in a row without repeating a word',
      },
      {
        tierIndex: 3,
        level: 'rare',
        descriptionOverride: 'Play 30 words in a row without repeating a word',
      },
      {
        tierIndex: 4,
        level: 'legendary',
        descriptionOverride: 'Finish a run without repeating a word (40+ words)',
      },
    ],
  },
]
